import LuxonDates from './luxon-filters'
import StringFilters from './string-filters'

export default {
    filters: {
        LuxonDates,
        StringFilters,
    },
    install: function(Vue) {
        const allFilters = this.filters
        Object.keys(allFilters).forEach(function(filterCollection) {
            Object.keys(allFilters[filterCollection]).forEach(function(filter) {
                Vue.filter(filter, allFilters[filterCollection][filter])
            })
        })
    },
}
